module.exports = __webpack_public_path__ + "static/media/lang-id.4f5c4edc.svg";